import { useState } from "react"

const Perfil = ({ user, datos, rol, provincias, submit, form, handleInputChange, loading, galleryImages, removeImage, replaceImage, billingForm, billingFiles, filePreview, billingLoading, handleBillingSubmit, handleBillingInputChange, handleBillingFileChange, downloadDocument }) => {
    const [activeTab, setActiveTab] = useState("info")

    const dataToIs = (user, param) => {
        let myUser = {};
        if (rol == 'adm') {
            myUser = {
                ...user,
                razon_social: user.nombre,
                description: '',
                website: datos?.website ?? null,
                url_facebook: datos?.url_facebook ?? null,
                url_instagram: datos?.url_instagram ?? null,
                images: datos?.imagen_desc_1 ? [
                    datos.imagen_desc_1,
                    datos.imagen_desc_2,
                    datos.imagen_desc_3,
                    datos.imagen_int_1,
                    datos.imagen_int_2,
                    datos.imagen_int_3,
                ] : null
            };
        }
        if (rol == 'sala') {
            myUser = {
                razon_social: datos.razon_social,
                nombre: datos.nombre,
                email: datos.email,
                telefono: datos.telefono,
                direccion: datos.direccion,
                localidad: datos.localidad,
                provincia: datos.provincia,
                website: datos.website,
                description: datos.descripcion,
                url_facebook: datos?.url_facebook ?? null,
                url_instagram: datos?.url_instagram ?? null,
                images: datos?.imagen_desc_1 ? [
                    datos.imagen_desc_1,
                    datos.imagen_desc_2,
                    datos.imagen_desc_3,
                    datos.imagen_int_1,
                    datos.imagen_int_2,
                    datos.imagen_int_3,
                ] : null,
            }
        }

        if (rol == 'prd') {
            myUser = {
                razon_social: datos.nombre,
                nombre: datos.nombre,
                email: datos.prd_email,
                telefono: datos.telefono,
                direccion: datos.direccion,
                localidad: datos.localidad,
                provincia: datos.provincia,
                website: datos.website,
                description: datos.descripcion,
                url_facebook: datos?.url_facebook ?? null,
                url_instagram: datos?.url_instagram ?? null,
                images: datos?.imagen_desc_1 ? [
                    datos.imagen_desc_1,
                    datos.imagen_desc_2,
                    datos.imagen_desc_3,
                    datos.imagen_int_1,
                    datos.imagen_int_2,
                    datos.imagen_int_3,
                ] : null
            }
        }

        return myUser[param];
    }

    const badgeStatus = (status_id) => {
        switch (status_id) {
            case 1: return (<span className="badge bg-success-subtle text-success border border-success-subtle">Activa</span>)
            case 2: return (<span className="badge bg-danger-subtle text-danger border border-danger-subtle">Inactivo</span>)
            default:
                break;
        }
    }

    const getImageUrl = (image) => {
        if (image instanceof File) {
            return URL.createObjectURL(image);
        }
        return `https://antesala.com.ar/assets/img/salas/${image}`;
    };

    const getDocumentPreview = (file, existingUrl) => {
        if (file instanceof File) {
            if (file.type.startsWith('image/')) {
                return URL.createObjectURL(file);
            }
            return null; // For PDFs, we'll show an icon
        }
        if (existingUrl) {
            return `https://antesala.com.ar/assets/documents/${existingUrl}`;
        }
        return null;
    };

    const isImageFile = (file) => {
        if (file instanceof File) {
            return file.type.startsWith('image/');
        }
        if (typeof file === 'string') {
            return /\.(jpg|jpeg|png|gif)$/i.test(file);
        }
        return false;
    };

    const isPdfFile = (file) => {
        if (file instanceof File) {
            return file.type === 'application/pdf';
        }
        if (typeof file === 'string') {
            return /\.pdf$/i.test(file);
        }
        return false;
    };
    return (
        <div className="container py-4" style={{ maxWidth: "1200px" }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h2 fw-bold mb-0">Mi Perfil - Antesala</h1>
                <div className="d-flex align-items-center gap-2">
                </div>
            </div>

            {/* Profile Summary Card */}
            <div className="card mb-4">
                <div className="card-body p-4">
                    <div className="row align-items-center">
                        <div className="col-md-auto text-center mb-3 mb-md-0">
                            <div className="position-relative d-inline-block">
                                <img
                                    src="/placeholder.svg?height=128&width=128"
                                    alt="El Cuenco"
                                    className="rounded-circle border"
                                    style={{ width: "128px", height: "128px", objectFit: "cover" }}
                                />
                                <button
                                    className="btn btn-secondary btn-sm rounded-circle position-absolute"
                                    style={{ bottom: "0", right: "0", width: "32px", height: "32px" }}
                                >
                                    <i className="bi bi-pencil"></i>
                                </button>
                            </div>
                        </div>

                        <div className="col-md flex-grow-1">
                            <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start gap-2 mb-3">
                                <h2 className="h3 fw-bold mb-0">
                                    {dataToIs(user, 'razon_social')}
                                </h2>
                                {badgeStatus(user.status_id)}
                            </div>
                            <p className="text-muted mb-3">
                                {user.roles[0].nombre == 'adm'
                                    ? 'Administrador'
                                    : user.roles[0].nombre == 'sala'
                                        ? 'Responsable de sala'
                                        : user.roles[0].nombre == 'prd'
                                            ? 'Responsable productor'
                                            : ''
                                }
                            </p>

                            <div className="row g-2">
                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-envelope text-muted"></i>
                                        <span>{dataToIs(user, 'email')}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-telephone text-muted"></i>
                                        <span>{dataToIs(user, 'telefono')}</span>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="d-flex align-items-center gap-2">
                                        <i className="bi bi-geo-alt text-muted"></i>
                                        <span>{`${dataToIs(user, 'direccion')} ${dataToIs(user, 'localidad')} ${dataToIs(user, 'provincia')}`}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-auto">
                            <button
                                className="btn text-white"
                                style={{ backgroundColor: "#f97316" }}
                                onClick={submit}
                                disabled={loading}
                            >
                                <i className="bi bi-pencil me-2"></i>
                                {loading ? 'Guardando...' : 'Guardar cambios'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Main Content */}
                <div className={`${rol == 'adm' ? 'd-none' : 'col-lg-8'}`}>
                    {/* Tabs */}
                    <ul className="nav nav-tabs mb-4" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                                onClick={() => setActiveTab("info")}
                                type="button"
                            >
                                Información
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "social" ? "active" : ""}`}
                                onClick={() => setActiveTab("social")}
                                type="button"
                                disabled={rol == 'adm' ? true : false}
                            >
                                Redes Sociales
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "description" ? "active" : ""}`}
                                onClick={() => setActiveTab("description")}
                                type="button"
                                disabled={rol == 'adm' ? true : false}
                            >
                                Descripción
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link ${activeTab === "gallery" ? "active" : ""}`}
                                onClick={() => setActiveTab("gallery")}
                                type="button"
                                disabled={rol == 'adm' || rol == 'prd' ? true : false}
                            >
                                Galería
                            </button>
                        </li>
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {/* Info Tab */}
                        {activeTab === "info" && (
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-1">Datos de mi sala</h5>
                                    <p className="card-text text-muted mb-0">Información básica sobre tu espacio</p>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label htmlFor="name" className="form-label fw-medium">
                                                Nombre
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                value={form?.nombre || ''}
                                                onChange={(e) => handleInputChange('nombre', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email" className="form-label fw-medium">
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                value={form?.email || ''}
                                                onChange={(e) => handleInputChange('email', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="social-reason" className="form-label fw-medium">
                                                Razón Social
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="social-reason"
                                                value={form?.razon_social || ''}
                                                onChange={(e) => handleInputChange('razon_social', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="phone" className="form-label fw-medium">
                                                Teléfono
                                            </label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                id="phone"
                                                value={form?.telefono || ''}
                                                onChange={(e) => handleInputChange('telefono', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="address" className="form-label fw-medium">
                                                Dirección
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="address"
                                                value={form?.direccion || ''}
                                                onChange={(e) => handleInputChange('direccion', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="localidad" className="form-label fw-medium">
                                                Localidad
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="localidad"
                                                value={form?.localidad || ''}
                                                onChange={(e) => handleInputChange('localidad', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="province" className="form-label fw-medium">
                                                Provincia
                                            </label>
                                            <select
                                                className="form-select"
                                                id="province"
                                                value={form?.provincia || ''}
                                                onChange={(e) => handleInputChange('provincia', e.target.value)}
                                            >
                                                <option value="">Seleccionar provincia</option>
                                                {provincias.map((provincia, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={provincia.provincia}
                                                        >{`${provincia.provincia}`}</option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="current-password" className="form-label fw-medium">
                                                Contraseña actual
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="current-password"
                                                value={form?.current_password || ''}
                                                onChange={(e) => handleInputChange('current_password', e.target.value)}
                                                placeholder="Ingrese contraseña actual para cambios"
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="new-password" className="form-label fw-medium">
                                                Nueva contraseña
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="new-password"
                                                value={form?.password || ''}
                                                onChange={(e) => handleInputChange('password', e.target.value)}
                                                placeholder="Dejar vacío para mantener actual"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <label className="form-label fw-medium">Ubicación</label>
                                        <div className="border rounded overflow-hidden p-0" style={{ height: "300px", backgroundColor: "#f8f9fa" }}>
                                            <iframe
                                                src={
                                                    "https://maps.google.com/?q=" +
                                                    encodeURI(
                                                        dataToIs(user, 'direccion') +
                                                        " " +
                                                        dataToIs(user, 'provincia') +
                                                        " " +
                                                        dataToIs(user, 'localidad')
                                                    ) +
                                                    "&z=14&t=m&output=embed"
                                                }
                                                width="100%"
                                                height="300px"
                                                style={{ border: "0" }}
                                                allowfullscreen=""
                                                loading="lazy"
                                                referrerpolicy="no-referrer-when-downgrade"
                                                className=""
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Social Tab */}
                        {activeTab === "social" && (
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-1">Links Sociales</h5>
                                    <p className="card-text text-muted mb-0">Conecta tus redes sociales (Opcional)</p>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label htmlFor="website" className="form-label fw-medium">
                                            <i className="bi bi-globe me-2"></i>Sitio Web
                                        </label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            id="website"
                                            value={form?.website || ''}
                                            onChange={(e) => handleInputChange('website', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="facebook" className="form-label fw-medium">
                                            <i className="bi bi-facebook me-2"></i>URL de Facebook
                                        </label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            id="facebook"
                                            value={form?.url_facebook || ''}
                                            onChange={(e) => handleInputChange('url_facebook', e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="instagram" className="form-label fw-medium">
                                            <i className="bi bi-instagram me-2"></i>URL de Instagram
                                        </label>
                                        <input
                                            type="url"
                                            className="form-control"
                                            id="instagram"
                                            value={form?.url_instagram || ''}
                                            onChange={(e) => handleInputChange('url_instagram', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Description Tab */}
                        {activeTab === "description" && (
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-1">Descripción de mi sala</h5>
                                    <p className="card-text text-muted mb-0">Escribe una reseña o descripción de tu sala</p>
                                </div>
                                <div className="card-body">
                                    <textarea
                                        className="form-control"
                                        rows={8}
                                        placeholder="Describe tu espacio, su historia, propuesta artística y cualquier información relevante para el público..."
                                        value={form?.descripcion || ''}
                                        onChange={(e) => handleInputChange('descripcion', e.target.value)}
                                    ></textarea>
                                </div>
                            </div>
                        )}

                        {/* Gallery Tab */}
                        {activeTab === "gallery" && rol === "sala" && (
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-1">Galería de imágenes</h5>
                                    <p className="card-text text-muted mb-0">Sube hasta 6 imágenes que muestren lo mejor de tu Sala (arrastra y suelta archivos)</p>
                                </div>
                                <div className="card-body">
                                    <div className="row g-3">
                                        {/* Existing/Uploaded Images */}
                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_desc_1'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_desc_1', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_desc_1')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_desc_2'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_desc_2', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_desc_2')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_desc_3'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_desc_3', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_desc_3')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_int_1'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_int_1', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_int_1')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_int_2'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_int_2', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_int_2')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="position-relative">
                                                <img
                                                    src={getImageUrl(galleryImages['imagen_int_3'])}
                                                    alt={`Imagen de galería`}
                                                    className="w-100 rounded"
                                                    style={{ aspectRatio: "1", objectFit: "cover" }}
                                                />
                                                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 rounded transition-opacity">
                                                    <div className="d-flex gap-2">
                                                        <label className="btn btn-light btn-sm">
                                                            <i className="bi bi-pencil me-1"></i>
                                                            Cambiar
                                                            <input
                                                                type="file"
                                                                className="d-none"
                                                                accept="image/*"
                                                                onChange={(e) => {
                                                                    if (e.target.files[0]) {
                                                                        replaceImage('imagen_int_3', e.target.files[0]);
                                                                    }
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                        </label>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage('imagen_int_3')}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Gallery Instructions */}
                                    <div className="mt-4 p-3 bg-light rounded">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <h6 className="fw-bold mb-2">Consejos para mejores fotos:</h6>
                                                <ul className="small text-muted mb-0">
                                                    <li>Usa imágenes de alta calidad con buena iluminación</li>
                                                    <li>Muestra diferentes ángulos y espacios de tu sala</li>
                                                    <li>Incluye fotos del escenario, butacas y áreas comunes</li>
                                                    <li>Evita fotos borrosas o muy oscuras</li>
                                                </ul>
                                            </div>
                                            <div className="col-md-4 text-end">
                                                <div className="badge bg-secondary p-2">
                                                    {galleryImages?.length || 0} / 6 imágenes
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Sidebar */}
                <div className={`${rol == 'adm' ? 'col-lg-12' : 'col-lg-4'} `}>
                    <div className="row g-4">
                        {/* Billing Card */}
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-1">Datos de facturación</h5>
                                    <p className="card-text text-muted mb-0">
                                        Rellena los datos de facturación para generar entradas más rápido
                                    </p>
                                </div>
                                <form onSubmit={handleBillingSubmit}>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label htmlFor="dato_fiscal" className="form-label fw-medium">
                                                CUIT/CUIL del titular
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="entidad"
                                                value={billingForm?.entidad || ''}
                                                onChange={(e) => handleBillingInputChange('entidad', e.target.value)}
                                                placeholder="Ej: 30699302314"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="email_billing" className="form-label fw-medium">
                                                Email de facturación
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email_billing"
                                                value={billingForm?.email || ''}
                                                onChange={(e) => handleBillingInputChange('email', e.target.value)}
                                                placeholder="email@ejemplo.com"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="cbu" className="form-label fw-medium">
                                                Número de CBU
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="cbu"
                                                value={billingForm?.cbu || ''}
                                                onChange={(e) => handleBillingInputChange('cbu', e.target.value)}
                                                placeholder="0000003100039540317756"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="porcentaje" className="form-label fw-medium">
                                                Porcentaje de liquidación
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="porcentaje"
                                                value={billingForm?.porcentaje || ''}
                                                onChange={(e) => handleBillingInputChange('porcentaje', e.target.value)}
                                                placeholder="Ej: 10%"
                                            />
                                        </div>

                                        {/* AFIP Document Upload */}
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label fw-medium mb-0">
                                                    Comprobante de AFIP *
                                                </label>
                                                {billingFiles?.comprobante_afip && (
                                                    <span className="badge bg-success">
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        Archivo seleccionado
                                                    </span>
                                                )}
                                            </div>

                                            {/* Preview Section */}
                                            {filePreview?.comprobante_afip && (
                                                <div className="mb-3 border rounded p-3 bg-white">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <h6 className="mb-0">Vista previa:</h6>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => handleBillingFileChange('comprobante_afip', null)}
                                                        >
                                                            <i className="bi bi-trash"></i> Eliminar
                                                        </button>
                                                    </div>

                                                    {filePreview.comprobante_afip.isExisting ? (
                                                        // Archivo existente desde el servidor (Object URL en caché)
                                                        <div>
                                                            {filePreview.comprobante_afip.type?.includes('pdf') ||
                                                             filePreview.comprobante_afip.fileName?.toLowerCase().endsWith('.pdf') ? (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_afip.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_afip.url}
                                                                        download={filePreview.comprobante_afip.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            ) : filePreview.comprobante_afip.type?.includes('image') ? (
                                                                <div className="text-center">
                                                                    <a
                                                                        href={filePreview.comprobante_afip.url}
                                                                        download={filePreview.comprobante_afip.fileName}
                                                                        title="Click para descargar"
                                                                    >
                                                                        <img
                                                                            src={filePreview.comprobante_afip.url}
                                                                            alt="Vista previa AFIP"
                                                                            className="img-fluid rounded"
                                                                            style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                                        />
                                                                    </a>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_afip.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_afip.url}
                                                                        download={filePreview.comprobante_afip.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : typeof filePreview.comprobante_afip === 'string' && filePreview.comprobante_afip !== 'pdf' ? (
                                                        <div className="text-center">
                                                            <img
                                                                src={filePreview.comprobante_afip}
                                                                alt="Vista previa AFIP"
                                                                className="img-fluid rounded"
                                                                style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    ) : filePreview.comprobante_afip === 'pdf' ? (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">PDF seleccionado</p>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_afip}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Upload Area */}
                                            <div className="border border-2 border-dashed rounded p-4 text-center bg-light position-relative">
                                                <input
                                                    type="file"
                                                    className="position-absolute w-100 h-100 opacity-0"
                                                    style={{ cursor: "pointer" }}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            handleBillingFileChange('comprobante_afip', e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                                <i className="bi bi-upload h4 text-muted"></i>
                                                <p className="mt-2 small text-muted mb-0">
                                                    {billingFiles?.comprobante_afip
                                                        ? 'Cambiar archivo'
                                                        : 'Subir archivo PDF o formato imagen JPG/JPEG/PNG (máx 10MB)'
                                                    }
                                                </p>
                                            </div>
                                        </div>

                                        {/* CBU Document Upload */}
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label fw-medium mb-0">
                                                    Comprobante de CBU *
                                                </label>
                                                {billingFiles?.comprobante_cbu && (
                                                    <span className="badge bg-success">
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        Archivo seleccionado
                                                    </span>
                                                )}
                                            </div>

                                            {/* Preview Section */}
                                            {filePreview?.comprobante_cbu && (
                                                <div className="mb-3 border rounded p-3 bg-white">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <h6 className="mb-0">Vista previa:</h6>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => handleBillingFileChange('comprobante_cbu', null)}
                                                        >
                                                            <i className="bi bi-trash"></i> Eliminar
                                                        </button>
                                                    </div>

                                                    {filePreview.comprobante_cbu.isExisting ? (
                                                        // Archivo existente desde el servidor (Object URL en caché)
                                                        <div>
                                                            {filePreview.comprobante_cbu.type?.includes('pdf') ||
                                                             filePreview.comprobante_cbu.fileName?.toLowerCase().endsWith('.pdf') ? (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_cbu.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_cbu.url}
                                                                        download={filePreview.comprobante_cbu.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            ) : filePreview.comprobante_cbu.type?.includes('image') ? (
                                                                <div className="text-center">
                                                                    <a
                                                                        href={filePreview.comprobante_cbu.url}
                                                                        download={filePreview.comprobante_cbu.fileName}
                                                                        title="Click para descargar"
                                                                    >
                                                                        <img
                                                                            src={filePreview.comprobante_cbu.url}
                                                                            alt="Vista previa CBU"
                                                                            className="img-fluid rounded"
                                                                            style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                                        />
                                                                    </a>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_cbu.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_cbu.url}
                                                                        download={filePreview.comprobante_cbu.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : typeof filePreview.comprobante_cbu === 'string' && filePreview.comprobante_cbu !== 'pdf' ? (
                                                        <div className="text-center">
                                                            <img
                                                                src={filePreview.comprobante_cbu}
                                                                alt="Vista previa CBU"
                                                                className="img-fluid rounded"
                                                                style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    ) : filePreview.comprobante_cbu === 'pdf' ? (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">PDF seleccionado</p>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_cbu}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Upload Area */}
                                            <div className="border border-2 border-dashed rounded p-4 text-center bg-light position-relative">
                                                <input
                                                    type="file"
                                                    className="position-absolute w-100 h-100 opacity-0"
                                                    style={{ cursor: "pointer" }}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            handleBillingFileChange('comprobante_cbu', e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                                <i className="bi bi-upload h4 text-muted"></i>
                                                <p className="mt-2 small text-muted mb-0">
                                                    {billingFiles?.comprobante_cbu
                                                        ? 'Cambiar archivo'
                                                        : 'Subir archivo PDF o formato imagen JPG/JPEG/PNG (máx 10MB)'
                                                    }
                                                </p>
                                            </div>
                                        </div>

                                        {/* Entity Document Upload */}
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label fw-medium mb-0">
                                                    Comprobante de entidad bancaria *
                                                </label>
                                                {billingFiles?.comprobante_entidad && (
                                                    <span className="badge bg-success">
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        Archivo seleccionado
                                                    </span>
                                                )}
                                            </div>

                                            {/* Preview Section */}
                                            {filePreview?.comprobante_entidad && (
                                                <div className="mb-3 border rounded p-3 bg-white">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <h6 className="mb-0">Vista previa:</h6>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => handleBillingFileChange('comprobante_entidad', null)}
                                                        >
                                                            <i className="bi bi-trash"></i> Eliminar
                                                        </button>
                                                    </div>

                                                    {filePreview.comprobante_entidad.isExisting ? (
                                                        // Archivo existente desde el servidor (Object URL en caché)
                                                        <div>
                                                            {filePreview.comprobante_entidad.type?.includes('pdf') ||
                                                             filePreview.comprobante_entidad.fileName?.toLowerCase().endsWith('.pdf') ? (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_entidad.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_entidad.url}
                                                                        download={filePreview.comprobante_entidad.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            ) : filePreview.comprobante_entidad.type?.includes('image') ? (
                                                                <div className="text-center">
                                                                    <a
                                                                        href={filePreview.comprobante_entidad.url}
                                                                        download={filePreview.comprobante_entidad.fileName}
                                                                        title="Click para descargar"
                                                                    >
                                                                        <img
                                                                            src={filePreview.comprobante_entidad.url}
                                                                            alt="Vista previa entidad bancaria"
                                                                            className="img-fluid rounded"
                                                                            style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                                        />
                                                                    </a>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center p-4">
                                                                    <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                                    <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_entidad.fileName}</p>
                                                                    <a
                                                                        href={filePreview.comprobante_entidad.url}
                                                                        download={filePreview.comprobante_entidad.fileName}
                                                                        className="btn btn-outline-primary btn-sm mt-2"
                                                                    >
                                                                        <i className="bi bi-download me-1"></i>Descargar documento
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : typeof filePreview.comprobante_entidad === 'string' && filePreview.comprobante_entidad !== 'pdf' ? (
                                                        <div className="text-center">
                                                            <img
                                                                src={filePreview.comprobante_entidad}
                                                                alt="Vista previa entidad bancaria"
                                                                className="img-fluid rounded"
                                                                style={{ maxHeight: "200px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    ) : filePreview.comprobante_entidad === 'pdf' ? (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark-pdf text-danger" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">PDF seleccionado</p>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center p-4">
                                                            <i className="bi bi-file-earmark text-primary" style={{ fontSize: "3rem" }}></i>
                                                            <p className="mt-2 mb-0 text-muted">{filePreview.comprobante_entidad}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Upload Area */}
                                            <div className="border border-2 border-dashed rounded p-4 text-center bg-light position-relative">
                                                <input
                                                    type="file"
                                                    className="position-absolute w-100 h-100 opacity-0"
                                                    style={{ cursor: "pointer" }}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            handleBillingFileChange('comprobante_entidad', e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                                <i className="bi bi-upload h4 text-muted"></i>
                                                <p className="mt-2 small text-muted mb-0">
                                                    {billingFiles?.comprobante_entidad
                                                        ? 'Cambiar archivo'
                                                        : 'Subir archivo PDF o formato imagen JPG/JPEG/PNG (máx 10MB)'
                                                    }
                                                </p>
                                            </div>
                                        </div>

                                        <div className="alert alert-info">
                                            <i className="bi bi-info-circle me-2"></i>
                                            <small>
                                                Los campos marcados con * son requeridos. Los documentos deben ser legibles y en formato PDF, JPG, JPEG o PNG.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn w-100 text-white"
                                            style={{ backgroundColor: "#f97316" }}
                                            disabled={billingLoading}
                                        >
                                            {billingLoading ? (
                                                <>
                                                    <i className="bi bi-hourglass-split me-2"></i>
                                                    Guardando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-save me-2"></i>
                                                    Guardar datos de facturación
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Help Card */}
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-0">Ayuda</h5>
                                </div>
                                <div className="card-body">
                                    <p className="card-text text-muted">
                                        ¿Necesitas ayuda para completar tu perfil? Contacta con nuestro equipo de soporte para resolver
                                        cualquier duda.
                                    </p>
                                    <button className="btn btn-outline-secondary w-100">Contactar soporte</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Perfil